
// Get all invoices
export const getInvoicesStart =()=>({
    type: "GET_INVOICES_START",
});
export const getInvoicesSuccess =(invoices)=>({
    type: "GET_INVOICES_SUCCESS",
    payload: invoices,
});
export const getInvoicesFailure =(error)=>({
    type: "GET_INVOICES_FAILURE",
    payload: error,
});

// Load Envois, Ramassage, Depot
export const getEnvoisRamassageDepotStart =()=>({
    type: "GET_ENVOIS_RAMASSAGE_DEPOT_START",
});
export const getEnvoisRamassageDepotSuccess =(collection)=>({
    type: "GET_ENVOIS_RAMASSAGE_DEPOT_SUCCESS",
    payload: collection,
});
export const getEnvoisRamassageDepotFailure =(error)=>({
    type: "GET_ENVOIS_RAMASSAGE_DEPOT_FAILURE",
    payload: error,
});

// Get Detail Invoice, Envois, Ramassage, Depot
export const getDetailInvoiceEnvoisRamassageDepotStart =()=>({
    type: "GET_DETAIL_INVOICE_ENVOIS_RAMASSAGE_DEPOT_START",
});
export const getDetailInvoiceEnvoisRamassageDepotSuccess =(collection)=>({
    type: "GET_DETAIL_INVOICE_ENVOIS_RAMASSAGE_DEPOT_SUCCESS",
    payload: collection,
});
export const getDetailInvoiceEnvoisRamassageDepotFailure =(error)=>({
    type: "GET_DETAIL_INVOICE_ENVOIS_RAMASSAGE_DEPOT_FAILURE",
    payload: error,
});


// Add one invoice
export const addInvoiceStart =()=>({
    type: "ADD_INVOICE_START",
});
export const addInvoiceSuccess =(invoice)=>({
    type: "ADD_INVOICE_SUCCESS",
    payload: invoice,
});
export const addInvoiceFailure =(error)=>({
    type: "ADD_INVOICE_FAILURE",
    payload: error,
});

// Update one invoice
export const updateInvoiceStart =()=>({
    type: "UPDATE_INVOICE_START",
});
export const updateInvoiceSuccess =(invoice)=>({
    type: "UPDATE_INVOICE_SUCCESS",
    payload: invoice,
});
export const updateInvoiceFailure =(error)=>({
    type: "UPDATE_INVOICE_FAILURE",
    payload: error,
});

// Delete one invoice
export const deleteInvoiceStart =()=>({
    type: "DELETE_INVOICE_START",
});
export const deleteInvoiceSuccess =(response)=>({
    type: "DELETE_INVOICE_SUCCESS",
    payload: response,
});
export const deleteInvoiceFailure =(error)=>({
    type: "DELETE_INVOICE_FAILURE",
    payload: error,
});